var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-text-wrapper"},[_c('TextEditor',{staticClass:"textarea",attrs:{"maxlength":"2000","value":_vm.editorVal},on:{"change":_vm.inputChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }